import { useState } from "react";
import { Trans } from "react-i18next";
import { t } from "i18next";
import { Modal } from "antd";
import { useAppDispatch } from "@hooks/redux";
import { fetchAiCredits } from "@store/globalSlice";
import CommonButton from "@components/CommonButton";

interface PayResultProps {
  visible: boolean;
  onCancel: () => void;
}

const PayResult = ({ visible, onCancel }: PayResultProps) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(fetchAiCredits());
    onCancel();
  };

  if (!visible) return null;

  return (
    <Modal
      title={t("Pay")}
      open={visible}
      centered={true}
      onCancel={handleClose}
      footer={
        <div className="flex items-center justify-center gap-[20px]">
          <CommonButton className="flex-1" size="large" onClick={handleClose}>
            <Trans>Payment failure</Trans>
          </CommonButton>
          <CommonButton size="large" className="flex-1" type="primary" onClick={handleClose}>
            <Trans>Payment success</Trans>
          </CommonButton>
        </div>
      }
      width={540}
    >
      <div className="mt-[20px] text-[18px]">
        <Trans>Please pay on the new page. After payment you can respond us the result.</Trans>
      </div>
    </Modal>
  );
};

export default PayResult;

export const usePayResult = () => {
  const [visible, setVisible] = useState(false);
  const payResult = <PayResult visible={visible} onCancel={() => setVisible(false)}></PayResult>;
  return {
    setVisible,
    payResult,
  };
};
